
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 96 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M67.935 12.469l2.478 2.732 2.387-2.732h5.095l-4.98 5.6 5.048 5.646h-5.3l-2.456-2.754-2.433 2.754h-5.119l5.004-5.623-5.004-5.623h5.28zM62.655 12.469v3.8h-5.667v3.486h5.667v3.96h-9.832V6h9.832v3.949h-5.667v2.52h5.667z","fill":"#748190"}}),_c('path',{attrs:{"d":"M48.675 6v7.25h-.045c-.92-1.056-2.066-1.423-3.397-1.423-2.727 0-4.781 1.855-5.502 4.305-.823-2.7-2.944-4.356-6.088-4.356-2.554 0-4.57 1.146-5.623 3.014V12.47h-5.278v-2.52h5.76V6H18.036v17.715h4.706v-7.447h4.69a7.055 7.055 0 00-.215 1.752c0 3.695 2.823 6.288 6.426 6.288 3.03 0 5.026-1.422 6.081-4.015h-4.032c-.545.78-.959 1.01-2.05 1.01-1.264 0-2.354-1.103-2.354-2.41h8.21c.357 2.935 2.644 5.466 5.78 5.466a4.02 4.02 0 003.35-1.79h.047v1.147h4.147V6h-4.147zM31.42 16.32c.26-1.124 1.134-1.86 2.224-1.86 1.199 0 2.027.713 2.245 1.86h-4.47zm14.738 4.698c-1.53 0-2.48-1.425-2.48-2.913 0-1.59.827-3.118 2.48-3.118 1.713 0 2.396 1.529 2.396 3.118 0 1.508-.723 2.913-2.396 2.913z","fill":"currentColor"}})])
          )
        }
      }
    